import { Temporal } from "./temporal";

export function parsePlainDate(value: unknown): Temporal.PlainDate | null {
  if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value))
    return null;
  try {
    return Temporal.PlainDate.from(value, { overflow: "reject" });
  } catch (error) {
    if (error instanceof RangeError) return null;
    throw error;
  }
}

export function parseInstant(value: unknown): Temporal.Instant | null {
  if (
    typeof value !== "string" ||
    !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,9})?)?(?:Z|[+-]\d{2}:\d{2})$/.test(
      value,
    )
  )
    return null;
  // Temporal допускает leap second с нормализацией; wire-контракт Mors — нет.
  if (value.slice(17, 19) === "60") return null;
  try {
    return Temporal.Instant.from(value);
  } catch (error) {
    if (error instanceof RangeError) return null;
    throw error;
  }
}

export function parsePlainTime(value: unknown): Temporal.PlainTime | null {
  if (typeof value !== "string" || !/^\d{2}:\d{2}$/.test(value)) return null;
  try {
    return Temporal.PlainTime.from(value, { overflow: "reject" });
  } catch (error) {
    if (error instanceof RangeError) return null;
    throw error;
  }
}

export function parseLocalDateTime(
  date: string,
  time: string,
): Temporal.PlainDateTime | null {
  const day = parsePlainDate(date);
  const wallTime = parsePlainTime(time);
  return day && wallTime ? day.toPlainDateTime(wallTime) : null;
}

/** Полностью введённая дата; частичная маска остаётся ответственностью формы. */
export function parseDate(value: string): string | null {
  const match = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(value);
  return match
    ? (parsePlainDate(`${match[3]}-${match[2]}-${match[1]}`)?.toString() ??
        null)
    : null;
}

export function serializeInstant(
  value: Temporal.Instant,
  precision: "second" | "millisecond",
): string {
  return value.toString({ smallestUnit: precision });
}

/** Отображение момента в оффсете самой wire-строки, без зоны браузера. */
export function parseOffsetInstant(
  value: string,
): Temporal.ZonedDateTime | null {
  const instant = parseInstant(value);
  if (!instant) return null;
  return instant.toZonedDateTimeISO(
    value.endsWith("Z") ? "UTC" : value.slice(-6),
  );
}

/** Локальная дата-время без оффсета, включая секунды устройства. */
export function parsePlainDateTime(
  value: unknown,
): Temporal.PlainDateTime | null {
  if (
    typeof value !== "string" ||
    !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,9})?)?$/.test(value) ||
    value.slice(17, 19) === "60"
  )
    return null;
  try {
    return Temporal.PlainDateTime.from(value, { overflow: "reject" });
  } catch (error) {
    if (error instanceof RangeError) return null;
    throw error;
  }
}
